import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aum-cli-info-component',
  templateUrl: './info-component.component.html',
  styleUrls: ['./info-component.component.scss']
})
export class InfoComponentComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string }
  ) {}
}
